import { Box } from '@chakra-ui/react'
import { ErrorMessage } from '@hookform/error-message'
import { useStore } from '@lib/context/store-context'
import React, { useState } from 'react'
import { Controller, get } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const PhoneNumberInput: React.FC<any> = ({
  value,
  control,
  onChange,
  nameInput,
  disabled,
  ...rest
}) => {
  const { getRegion } = useStore()

  const [countryCode, setCountryCode] = useState(
    getRegion()?.countryCode ?? 'sg'
  )

  return (
    <Controller
      control={control}
      {...rest}
      render={({ field: { value, onChange, name }, formState: { errors } }) => {
        const hasError = get(errors, name)

        return (
          <Box>
            <PhoneInput
              value={value}
              enableSearch={true}
              country={countryCode}
              onChange={(value: any, data: any) => {
                if (
                  (value as string).length < (data.dialCode as string).length
                ) {
                  setCountryCode(data.countryCode)
                  onChange(data.dialCode)
                } else {
                  onChange(value)
                }
              }}
              {...rest}
              disabled={disabled}
              inputStyle={{
                height: '50px',
                fontSize: '15px',
                borderRadius: '0px'
              }}
            />
            {hasError && (
              <Box>
                <ErrorMessage
                  errors={errors}
                  name={name}
                  render={({ message }) => {
                    return (
                      <div className="pt-1 pl-2 text-rose-500 text-small-regular">
                        <span>{message}</span>
                      </div>
                    )
                  }}
                />
              </Box>
            )}
          </Box>
        )
      }}
    />
  )
}

export default PhoneNumberInput
